//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	import axios from 'axios'

	export default {
		name: "mobileDevice",
		data() {
			return {
				list: []
			}
		},
		methods: {
			getList() {
				this.$http.getMobileAndDevice('/v1/api/user/mobile/deviceConfig').then(res => {
					let data = res.data.body.mobileDeviceConfig
					this.list = data
				})
			},
			link(item, index){
        let id = 124
        switch (index){
          case 0:
            id=124;
            break
          case 1:
            id=125;
            break
          case 2:
            id=153;
            break
          case 3:
            id=154;
            break
        }
        let param = { 'body': {
            'funcItemId': id
          } }
        this.$http.post('/v1/api/ad/homepage/userVisitedFunc', param) // 埋点
            .then((res) => {
            })
				window.location.href = item.link
			}
		},
		mounted() {
		},
		created() {
			this.getList()
		}
	}



// WEBPACK FOOTER //
// ./src/page/mobileDevice/index.vue